import { render, staticRenderFns } from "./SquadsManagement.vue?vue&type=template&id=702a1320&scoped=true"
import script from "./SquadsManagement.vue?vue&type=script&lang=js"
export * from "./SquadsManagement.vue?vue&type=script&lang=js"
import style0 from "./SquadsManagement.vue?vue&type=style&index=0&id=702a1320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a1320",
  null
  
)

export default component.exports